import * as z from 'zod';

import { Tab } from '../../Tabs/Tabs';

const ACCEPTED_IMAGE_TYPES = [
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/svg',
  'application/json'
];

export enum EImageUploadModalTabs {
  UPLOAD = 'upload',
  MEDIA = 'media'
}

export const IMAGE_UPLOAD_TABS: Tab[] = [
  { id: EImageUploadModalTabs.UPLOAD, value: 'Upload' },
  { id: EImageUploadModalTabs.MEDIA, value: 'Media' }
];

export enum EImageTypeOptions {
  GENERAL = 'general',
  PRODUCTS = 'product',
  LOGO = 'logo',
  MOBILE_BACKGROUND = 'bgMobile',
  DESKTOP_BACKGROUND = 'bgDesk',
  BUNDLE_BACKGROUND = 'bgBundle',
  POPUP_BACKGROUND = 'bgPopup',
  FAVICON = 'favicon',
  PRODUCT_PREFIX = 'productPrefix',
  BANNER = 'banner',
  PLAYER_LEVEL = 'playerLevel',
  SECTION = 'section',
  ADD_TO_HOME_BUTTON_IMAGE = 'addToHomeButtonImage',
  ADD_TO_HOME_ICON_IMAGE = 'addToHomeIconImage',
  BACK_TO_GAME_BUTTON_IMAGE = 'backToGameButtonImage',
  TRAIT = 'trait'
}

export const MEDIA_TYPE_OPTIONS = [
  {
    value: EImageTypeOptions.GENERAL,
    label: 'General'
  },
  {
    value: EImageTypeOptions.PRODUCTS,
    label: 'Products'
  },
  {
    value: EImageTypeOptions.LOGO,
    label: 'Logo'
  },
  {
    value: EImageTypeOptions.MOBILE_BACKGROUND,
    label: 'Mobile background'
  },
  {
    value: EImageTypeOptions.DESKTOP_BACKGROUND,
    label: 'Desktop background'
  },
  {
    value: EImageTypeOptions.BUNDLE_BACKGROUND,
    label: 'Build background'
  },
  {
    value: EImageTypeOptions.POPUP_BACKGROUND,
    label: 'PopUp background'
  },
  {
    value: EImageTypeOptions.FAVICON,
    label: 'Favicon'
  },
  {
    value: EImageTypeOptions.PRODUCT_PREFIX,
    label: 'Product Prefix'
  },
  {
    value: EImageTypeOptions.BANNER,
    label: 'Banner'
  },
  {
    value: EImageTypeOptions.PLAYER_LEVEL,
    label: 'Player level'
  },
  {
    value: EImageTypeOptions.SECTION,
    label: 'Section'
  },
  {
    value: EImageTypeOptions.ADD_TO_HOME_BUTTON_IMAGE,
    label: 'Button image'
  },
  {
    value: EImageTypeOptions.ADD_TO_HOME_ICON_IMAGE,
    label: 'Icon image'
  },
  {
    value: EImageTypeOptions.BACK_TO_GAME_BUTTON_IMAGE,
    label: 'Back To Game Button'
  },
  {
    value: EImageTypeOptions.TRAIT,
    label: 'Trait'
  }
];

export const IMG_UPLOAD_FORM_SCHEMA = z
  .object({
    mediaId: z.string(),
    type: z.string().optional(),
    image: z.union([z.instanceof(File), z.null()]),
    tab: z.enum(['upload', 'media'])
  })
  .refine(
    (data) => {
      if (data.tab === 'upload') {
        return data.mediaId?.trim() && data.image;
      }
      return true;
    },
    {
      message: 'Please fill required fields for upload tab',
      path: ['mediaId']
    }
  );
